import './header.scss';

import React, { useState } from 'react';
import { Storage, Translate } from 'react-jhipster';
import { Nav, Navbar, NavbarCollapse, NavbarToggle } from 'react-bootstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { setLocale } from 'app/shared/reducers/locale';
// import { AccountMenu, AdminMenu, EntitiesMenu, LocaleMenu } from '../menus'; // generated
import { AccountMenu, AdminMenu, LocaleMenu } from '../menus'; // custom
import { Brand, Home } from './header-components';

export interface IHeaderProps {
  isAuthenticated: boolean;
  isAdmin: boolean;
  ribbonEnv: string;
  isInProduction: boolean;
  isOpenAPIEnabled: boolean;
  currentLocale: string;
}

const Header = (props: IHeaderProps) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const isLoading = useAppSelector(state => state.loadingBar.activeRequests > 0);

  const dispatch = useAppDispatch();

  const handleLocaleChange = event => {
    const langKey = event.target.value;
    Storage.session.set('locale', langKey);
    dispatch(setLocale(langKey));
  };

  const renderDevRibbon = () =>
    props.isInProduction === false ? (
      <div className="ribbon dev">
        <a href="">
          <Translate contentKey={`global.ribbon.${props.ribbonEnv}`} />
        </a>
      </div>
    ) : null;

  /* jhipster-needle-add-element-to-menu - JHipster will add new menu items here */

  return (
    <div>
      {!location.pathname.includes('/timelog') && (
        <div id="app-header">
          {renderDevRibbon()}
          <div className={`loading-bar${isLoading ? ' loading-bar-active' : ''}`} />
          <Navbar data-cy="navbar" variant="dark" expand="md" fixed="top" className="bg-primary" expanded={menuOpen} onToggle={setMenuOpen}>
            <NavbarToggle label="Menu" />
            <Brand />
            <NavbarCollapse>
              <Nav id="header-tabs" className="ms-auto">
                <Home />
                {/*
            {props.isAuthenticated && <EntitiesMenu />}
            */}
                {props.isAuthenticated && props.isAdmin && <AdminMenu showOpenAPI={props.isOpenAPIEnabled} />}
                <LocaleMenu currentLocale={props.currentLocale} onClick={handleLocaleChange} />
                <AccountMenu isAuthenticated={props.isAuthenticated} />
              </Nav>
            </NavbarCollapse>
          </Navbar>
        </div>
      )}
    </div>
  );
};

export default Header;
